import {useTextStyles} from "@webteam/typography";
import Layout from "../components/layout";
import Seo from "../components/seo";
import {colCn, Container, rowCn} from "@webteam/layout";
import { privacy } from "@webteam/data-services";
import {useEffect, useRef, useState} from "react";
import {
	Form,
	Input,
	PrivacyNotice,
	SubmitButton,
	createFormServiceSubmitter,
	Textarea,
	useFormField
} from '@webteam/forms';
import React from "react";
import cn from "classnames";
import {useTheme, ThemeProvider} from "@webteam/ui-contexts";
import * as styles from "./feedback.module.css";

const formId = 'youtrack-ktor-feedback';
const formServiceId = 'https://forms-service.jetbrains.com/feedback';
const submitter = createFormServiceSubmitter(formServiceId);

const SubmitMessageComponent = () => {
	const textCn = useTextStyles();

	return (
		<div className={textCn('wt-text-1', { flow: true })}>
			Thank you for your feedback!
		</div>
	);
};

const Feedback = () => {
	const textCn = useTextStyles();
	const theme = useTheme();

	return (
		<Layout>
			<Seo title="Feedback" />

			<Container className="page-offset-top">
				<h1 className={textCn('wt-h1')}>Share Your Feedback on API and Docs</h1>

				<div className={cn(rowCn({size: "m"}), 'wt-offset-top-24')}>
					<div className={colCn({sm: 12, default: 6})}>
						<Form formId={formId} submitter={submitter} submitMessage={SubmitMessageComponent}>
							<Input
								label="API symbol"
								name={'apiSymbol'}
								required
								type={"text"}
								theme={theme}
							/>

							<WorkAroundForInitialValue />

							<Textarea
								label="Describe the Issue or Suggest Improvements"
								name={'content'}
								required
								minRows={3}
								className={'wt-offset-top-24'}
								theme={theme}
							/>

							<div className={rowCn({size: "m"})}>
								<div className={colCn({sm: 12, default: 6})}>
									<Input
										label="Your Name"
										name={'name'}
										className={'wt-offset-top-12'}
										required
										theme={theme}
									/>
								</div>
								<div className={colCn({sm: 12, default: 6})}>
									<Input
										label="Email Address"
										type="email"
										name={'email'}
										validators="email"
										required
										className={ 'wt-offset-top-12'}
										theme={theme}
									/>
								</div>
							</div>

							<PrivacyNotice size={"s"} consentId={privacy.consent.JB_INTENTION} className={cn('wt-offset-top-24', styles.privacyNoticeWrapper)} />

							<SubmitButton className="wt-offset-top-24">Submit</SubmitButton>
						</Form>
					</div>
				</div>
			</Container>
		</Layout>
)
}

// Webteam text field doesn't support initial value
function WorkAroundForInitialValue() {
	const fieldName = "apiSymbol";
	const { setValue } = useFormField(fieldName, {
		type: "string",
	});

	useEffect(() => {
		const params = new URLSearchParams(window.location.search);
		const fqnameParam = params.get("fqname");

		if (fqnameParam) {
				setValue(fqnameParam);
		}
	}, []);

	return <></>;
}

export default Feedback;
